import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../api.service';
import { FoldersDataService } from './folders-data.service';

@Component({
  selector: 'app-folders',
  templateUrl: './folders.component.html',
  styleUrls: ['./folders.component.scss']
})
export class FoldersComponent {
  queryParams: any = {};
  studyDetails: any = {};
  name: string = '';
  studyId: any = '';
  centers: string = '';
  subjectId: string = '';
  studyForm: any;
  subjectForm: any;
  selectedForm: string | null = null;
  formName: string | null = null;

  // Template data (similar to ecrf-template component)
  template: any = null;
  templateId: string = '';
  loading: boolean = false;

  // Edit field modal properties
  isEditFieldModalOpen = false;
  selectedField: any = null;
  editFieldValue: string = '';
  editReason: string = '';

  formData = {
    showDateField: '',
    selectedDate: '',
  };

  scheduleForms = [
  { label: "SCHEDULE-ACTIVITIES", route: "Schedule-Activities" }];
  
  
  screeningForms = [
    { label: "INFORMED CONSENT", route: "informed-consent" },
    { label: "SCREENING VISIT DATE ", route: "Screening Visit Date" },
    { label: "DEMOGRAPHY", route: "demography" },
    { label: "ANTHROPOMETRIC DATA", route: "anthropometric-data" },
    { label: "MEDICAL HISTORY", route: "medical-history" },
    { label: "PRIOR MEDICATION", route: "prior-medication" },
    { label: "VITAL SIGNS: (UPTO 3 DAYS)", route: "vital-signs" },
    { label: "PHYSICAL AND SYSTEMIC EXAMINATION", route: "physical-exam" },
    { label: "URINE PREGNANCY TEST", route: "pregnancy-declaration" },
    { label: "IDRS - INDIAN DIABETES RISK SCORE ASSESSMENT", route: "idrs" },
    { label: "LABORATORY INVESTIGATION", route: "laboratory-investigation" },
    { label: "ASSESSMENT OF INCLUSION AND EXCLUSION CRITERIA", route: "inclusion-exclusion" },
    { label: "ELIGIBILITY ASSESSMENT", route: "eligibility-assessment" },
    { label: "END OF SCREENING VISIT", route: "end-of-screening" }

  ];

  baselineForms = [
    { label: "BASELINE RECORD", route: "baseline-record" },
    { label: "PRAKRITI ANALYSIS", route: "baseline-prakriti-analysis" },
    { label: "VITAL SIGNS", route: "baseline-vital-signs" },
    { label: "PHYSICAL AND SYSTEMIC EXAMINATION", route: "baseline-physical-exam" },
    { label: "URINE PREGNANCY TEST", route: "baseline-pregnancy-declaration" },
    { label: "LABORATORY INVESTIGATION", route: "baseline-lab-investigation" },
    { label: "ANTHROPOMETRIC DATA", route: "baseline-anthropometric-data" },
    { label: "DIET ASSESSMENT", route: "baseline-diet-assessment" },
    { label: "LIFESTYLE ASSESSMENT", route: "baseline-lifestyle-assessment" },
    { label: "DETAILS OF INTERVENTION", route: "baseline-intervention-details" },
    { label: "7.STUDY PRODUCT/ADT-ABLI KIT DISPENSING RECORD:", route: "baseline-product-dispensing" },
    { label: "REVIEW OF ADVERSE EVENTS AND CONCOMITANT MEDICATION", route: "baseline-adverse-events" },
    { label: "END OF BASELINE VISIT", route: "baseline-end-visit" }
  ];

  medicineDispensingForms = [
    { label: "MEDICINE DISPENSING VISIT DATE", route: "medicine-dispensing-visit-date" },
    { label: "VITAL SIGNS", route: "medicine-vital-signs" },
    { label: "URINE PREGNANCY TEST", route: "medicine-pregnancy-declaration" },
    { label: "ANTHROPOMETRIC DATA", route: "medicine-anthropometric-data" },
    { label: "STUDY PRODUCT RETRIEVAL", route: "medicine-product-retrieval" },
    { label: "STUDY PRODUCT ACCOUNTABILITY", route: "medicine-product-accountability" },
    { label: "STUDY PRODUCT COMPLIANCE", route: "medicine-product-compliance" },
    { label: "STUDY PRODUCT DISPENSING RECORD", route: "medicine-product-dispensing-record" },
    { label: "REVIEW OF ADVERSE EVENTS AND CONCOMITANT MEDICATION", route: "medicine-adverse-events" },
    { label: "END OF THE VISIT", route: "medicine-end-visit" }
  ];

  studyCompletionForms = [
    { label: "STUDY COMPLETION / TERMINATION RECORD", route: "study-completion-termination-record" },
    { label: "REASON FOR DISCONTINUATION", route: "reason-for-discontinuation" }
  ];

  followupForms = [
    { label: "FOLLOW-UP-VISIT (Every 4th Month)", route: "follow-up-visit" },
    { label: "VITAL SIGNS", route: "follow-up-vital-signs" },
    { label: "PHYSICAL AND SYSTEMIC EXAMINATION", route: "follow-up-physical" },
    { label: "LABORATORY INVESTIGATION", route: "follow-up-laboratory-investigation" },
    { label: "URINE PREGNANCY TEST", route: "follow-up-pregnancy-declaration" },
    { label: "ANTHROPOMETRIC DATA", route: "follow-up-anthropometric-data" },
    { label: "STUDY PRODUCT RETRIEVAL", route: "follow-up-product-retrieval" },
    { label: "STUDY PRODUCT ACCOUNTABILITY", route: "follow-up-product-accountability" },
    { label: "STUDY PRODUCT COMPLIANCE", route: "follow-up-product-compliance" },
    { label: "STUDY PRODUCT DISPENSING RECORD", route: "follow-up-product-dispensing-record" },
    { label: "REVIEW OF ADVERSE EVENTS AND CONCOMITANT MEDICATION", route: "follow-up-adverse-events" },
  ];
  adverseEventsForms = [
    { label: "ADVERSE EVENT REPORT", route: "adverse-event-report" },
  ];

  signatureForms = [
    { label: "PRINCIPAL INVESTIGATOR'S SIGNATURE", route: "principal-investigator-signature" },
  ];

  protocolDeviationForms = [
    { label: "PROTOCOL DEVIATION/ VIOLATION/ WAIVER LOG", route: "protocol-deviation-log" }
  ];
  concomitantMedicationForms = [
    { label: "CONCOMITANT MEDICATION LOG", route: "concomitant-medication-log" }
  ];
  rescueMedicationForms = [
    { label: "RESCUE MEDICATION LOG", route: "rescue-medication-log" }
  ];
  
  priorMedicationForms = [
    { label: "PRIOR MEDICATION LOG", route: "prior-medication-log" }
  ];
  medicalHistoryForms = [
    { label: "MEDICAL HISTORY", route: "medical-history" }
];
vitalSignsForms = [
  { label: "VITAL SIGNS", route: "vital-signs" }
];
physicalSystemicForms = [
  { label: "PHYSICAL AND SYSTEMIC EXAMINATION", route: "physical-systemic" }
];
laboratoryForms = [
  { label: "LABORATORY INVESTIGATION", route: "laboratory-investigation-log" }
];
idrsForms = [
  { label: "IDRS Form", route: "idrs-form-log" }
];

  isScreeningVisible: boolean = false;
  isBaselineVisible: boolean = false;
  isMedicineDispensingVisible: boolean = false;
  isStudyCompletionVisible: boolean = false; // Added for Study Completion
  isFollowupVisible: boolean = false;
  isAdverseEventsVisible: boolean = false;
  isSignatureVisible: boolean = false;
  isProtocolDeviationVisible: boolean = false;
isProtocolDeviationRecorded: string = '';
isConcomitantMedicationVisible: boolean = false;
isRescueMedicationVisible: boolean = false;
isPriorMedicationVisible: boolean = false;
isMedicalHistoryVisible: boolean = false;
isVitalSignsVisible: boolean = false;
isPhysicalSystemicVisible: boolean = false;
isLaboratoryVisible: boolean = false;
isIDRSVisible: boolean = false;
isScheduleOfActivitiesVisible: boolean = false;

  selectedFolder: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private apiService: ApiService,
    private router: Router,
    private foldersDataService: FoldersDataService
  ) {}

  ngOnInit(): void {
    console.log(`Runs whenever folders is mentioned in url`);
    this.route.queryParamMap.subscribe(params => {
      this.queryParams.study_id = params.get('study_id');
      this.queryParams.template_name = params.get('template_name');
      
      // Load template data when we have template_name
      if (this.queryParams.template_name) {
        // this.loadTemplateData();
      }
    });
    console.log('Query params:', this.queryParams);
  }

  

  // Method to select folder from query parameter
  selectFolderFromParam(folderName: string): void {
    // Reset all visibility flags
    this.isScheduleOfActivitiesVisible = false;
    this.isScreeningVisible = false;
    this.isBaselineVisible = false;
    this.isMedicineDispensingVisible = false;
    this.isFollowupVisible = false;
    this.isAdverseEventsVisible = false;
    this.isSignatureVisible = false;
    this.isProtocolDeviationVisible = false;
    this.isConcomitantMedicationVisible = false;
    this.isRescueMedicationVisible = false;
    this.isPriorMedicationVisible = false;
    this.isMedicalHistoryVisible = false;
    this.isVitalSignsVisible = false;
    this.isPhysicalSystemicVisible = false;
    this.isLaboratoryVisible = false;
    this.isIDRSVisible = false;
    this.isStudyCompletionVisible = false;

    // Set the appropriate folder visibility based on the parameter
    switch (folderName) {
      case 'ScheduleOfActivities':
        this.isScheduleOfActivitiesVisible = true;
        break;
      case 'Screening Visit':
        this.isScreeningVisible = true;
        break;
      case 'Baseline Visit':
        this.isBaselineVisible = true;
        break;
      case 'Medicine Dispensing Visit':
        this.isMedicineDispensingVisible = true;
        break;
      case 'Followup Visit':
        this.isFollowupVisible = true;
        break;
      case 'Adverse Events Records Log':
        this.isAdverseEventsVisible = true;
        break;
      case "Principal Investigator's Signature":
        this.isSignatureVisible = true;
        break;
      case 'Protocol Deviation / Violation / Waiver Log':
        this.isProtocolDeviationVisible = true;
        break;
      case 'Concomitant Medication Log':
        this.isConcomitantMedicationVisible = true;
        break;
      case 'Rescue Medication Log':
        this.isRescueMedicationVisible = true;
        break;
      case 'Prior Medication Log':
        this.isPriorMedicationVisible = true;
        break;
      case 'Medical History':
        this.isMedicalHistoryVisible = true;
        break;
      case 'Vital Signs':
        this.isVitalSignsVisible = true;
        break;
      case 'Physical and Systemic Examination':
        this.isPhysicalSystemicVisible = true;
        break;
      case 'Laboratory Investigation':
        this.isLaboratoryVisible = true;
        break;
      case 'IDRS':
        this.isIDRSVisible = true;
        break;
      case 'Study Completion / Termination Record':
        this.isStudyCompletionVisible = true;
        break;
    }
  }
  
  onFolderClick(folderName: string): void {
    this.selectedFolder = folderName;
    if (folderName === 'ScheduleOfActivities') {
      this.isScheduleOfActivitiesVisible = !this.isScheduleOfActivitiesVisible;
      this.isIDRSVisible = false;
      this.isLaboratoryVisible = false;
      this.isPhysicalSystemicVisible = false;
      this.isVitalSignsVisible = false;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
      this.isProtocolDeviationVisible = false;
      this.isConcomitantMedicationVisible = false;
      this.isRescueMedicationVisible = false;
      this.isPriorMedicationVisible = false;
      this.isMedicalHistoryVisible = false;
    }
  
   else if (folderName === 'Screening Visit') {
      this.isScreeningVisible = !this.isScreeningVisible;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
    } else if (folderName === 'Baseline Visit') {
      this.isBaselineVisible = !this.isBaselineVisible;
      this.isScreeningVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
    } else if (folderName === 'Medicine Dispensing Visit') {
      this.isMedicineDispensingVisible = !this.isMedicineDispensingVisible;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
    } else if (folderName === 'Study Completion / Termination Record') {
      this.isStudyCompletionVisible = !this.isStudyCompletionVisible;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
    } else if (folderName === 'Followup Visit') {
      this.isFollowupVisible = !this.isFollowupVisible;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isSignatureVisible = false;
    } else if (folderName === 'Adverse Events Records Log') {
      this.isAdverseEventsVisible = !this.isAdverseEventsVisible;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
      this.isProtocolDeviationVisible = false;
    }
     else if (folderName === 'Principal Investigator\'s Signature') {
      this.isSignatureVisible = !this.isSignatureVisible;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
    }
    else if (folderName === 'Protocol Deviation / Violation / Waiver Log') {
      this.isProtocolDeviationVisible = !this.isProtocolDeviationVisible;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
    }
    else if (folderName === 'Concomitant Medication Log') {
      this.isConcomitantMedicationVisible = !this.isConcomitantMedicationVisible;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
      this.isProtocolDeviationVisible = false;
    }
    else if (folderName === 'Rescue Medication Log') {
      this.isRescueMedicationVisible = !this.isRescueMedicationVisible;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
      this.isProtocolDeviationVisible = false;
    }
    else if (folderName === 'Prior Medication Log') {
      this.isPriorMedicationVisible = !this.isPriorMedicationVisible;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
      this.isProtocolDeviationVisible = false;
      this.isConcomitantMedicationVisible = false;
      this.isRescueMedicationVisible = false;
     
    }
    else if (folderName === 'Medical History') {
      this.isMedicalHistoryVisible = !this.isMedicalHistoryVisible;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
      this.isProtocolDeviationVisible = false;
      this.isConcomitantMedicationVisible = false;
      this.isRescueMedicationVisible = false;
      this.isPriorMedicationVisible = false;
    }
    else if (folderName === 'Vital Signs') {
      this.isVitalSignsVisible = !this.isVitalSignsVisible;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
      this.isProtocolDeviationVisible = false;
      this.isConcomitantMedicationVisible = false;
      this.isRescueMedicationVisible = false;
      this.isPriorMedicationVisible = false;
      this.isMedicalHistoryVisible = false;
    }
    else if (folderName === 'Physical and Systemic Examination') {  // FIXED
      this.isPhysicalSystemicVisible = !this.isPhysicalSystemicVisible;
      this.isVitalSignsVisible = false; // Ensure only one section is open at a time
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
      this.isProtocolDeviationVisible = false;
      this.isConcomitantMedicationVisible = false;
      this.isRescueMedicationVisible = false;
      this.isPriorMedicationVisible = false;
      this.isMedicalHistoryVisible = false;
    }
    else if (folderName === 'Laboratory Investigation') {
      this.isLaboratoryVisible = !this.isLaboratoryVisible;
      this.isPhysicalSystemicVisible = false;
      this.isVitalSignsVisible = false;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
      this.isProtocolDeviationVisible = false;
      this.isConcomitantMedicationVisible = false;
      this.isRescueMedicationVisible = false;
      this.isPriorMedicationVisible = false;
      this.isMedicalHistoryVisible = false;
    }
    else if (folderName === 'IDRS') {
      this.isIDRSVisible = !this.isIDRSVisible;
      this.isLaboratoryVisible = false;
      this.isPhysicalSystemicVisible = false;
      this.isVitalSignsVisible = false;
      this.isScreeningVisible = false;
      this.isBaselineVisible = false;
      this.isMedicineDispensingVisible = false;
      this.isFollowupVisible = false;
      this.isSignatureVisible = false;
      this.isProtocolDeviationVisible = false;
      this.isConcomitantMedicationVisible = false;
      this.isRescueMedicationVisible = false;
      this.isPriorMedicationVisible = false;
      this.isMedicalHistoryVisible = false;
    }
}

navigateToSchedule(formRoute: string): void {
  this.selectedForm = formRoute;
  this.router.navigate(['/folders', 'schedule-of-activities', formRoute], {
    queryParams: {
      studyId: this.queryParams.study_id,
      subjectId: this.queryParams.subjectId || '',
      templateId: this.templateId
    }
  });
}

  navigateToScreening(formRoute: string) {
    this.selectedForm = formRoute;
    this.router.navigate(['/folders', 'screening-visits', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
  }

  navigateToBaseline(formRoute: string) {
    this.selectedForm = formRoute;
    this.router.navigate(['/folders', 'baseline-visits', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
  }

  navigateToMedicineDispensing(formRoute: string) {
    this.selectedForm = formRoute;
    this.router.navigate(['/folders', 'medicine-dispensing-visit', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
  }
  navigateToStudyCompletion(formRoute: string) {
    this.selectedForm = formRoute;
    this.router.navigate(['/folders', 'study-completion-termination', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
  }
   
  navigateToFollowup(formRoute: string) {
    this.selectedForm = formRoute;
    this.router.navigate(['/folders', 'follow-up-visit', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
  }
  navigateToAdverseEvents(formRoute: string) {
    this.selectedForm = formRoute;
    console.log('Navigating to:', formRoute, 'with queryParams:', this.queryParams);
    this.router.navigate(['/folders', 'adverse-events', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
  }

  navigateToSignature(formRoute: string) {
    this.selectedForm = formRoute;
    console.log('Navigating to:', formRoute, 'with queryParams:', this.queryParams);
    this.router.navigate(['/folders', 'principal-investigator-signature', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
  }
  navigateToProtocolDeviation(formRoute: string) {
    this.selectedForm = formRoute;
    this.router.navigate(['/folders', 'protocol-deviation', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
  }
  
  navigateToConcomitantMedication(formRoute: string) {
    this.selectedForm = formRoute;
    this.router.navigate(['/folders', 'concomitant-medication', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
  }
  navigateToRescueMedication(formRoute: string) {
    this.selectedForm = formRoute;
    this.router.navigate(['/folders', 'rescue-medication', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
  }
  
  navigateToPriorMedication(formRoute: string) {
    this.selectedForm = formRoute;
    this.router.navigate(['/folders', 'prior-medication', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
  }
  navigateToMedicalHistory(formRoute: string) {
    this.selectedForm = formRoute;
    this.router.navigate(['/folders', 'medical-history', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
}
navigateToVitalSigns(formRoute: string) {
  this.selectedForm = formRoute;
  this.router.navigate(['/folders', 'vital-signs', formRoute], {
    queryParams: {
      studyId: this.queryParams.study_id,
      subjectId: this.queryParams.subjectId || '',
      templateId: this.templateId
    }
  });
}

navigateToPhysicalSystemic(formRoute: string) {
  this.selectedForm = formRoute;
    this.router.navigate(['/folders', 'physical-systemic', formRoute], {
      queryParams: {
        studyId: this.queryParams.study_id,
        subjectId: this.queryParams.subjectId || '',
        templateId: this.templateId
      }
    });
}
navigateToLaboratory(formRoute: string) {
  this.selectedForm = formRoute;
  this.router.navigate(['/folders', 'laboratory-investigation-log', formRoute], {
    queryParams: {
      studyId: this.queryParams.study_id,
      subjectId: this.queryParams.subjectId || '',
      templateId: this.templateId
    }
  });
}

navigateToIDRS(formRoute: string): void {
  this.selectedForm = formRoute;
  this.router.navigate(['/folders', 'idrs', formRoute], {
    queryParams: {
      studyId: this.queryParams.study_id,
      subjectId: this.queryParams.subjectId || '',
      templateId: this.templateId
    }
  });
}
  selectFolder(folderName: string): void {
    this.selectedFolder = folderName;
  }

  showForm(formName: string) {
    this.selectedForm = formName;
  }

  closeForm() {
    this.selectedForm = null;
  }

  goBack(): void {
    this.router.navigate(['/study-details']);
  }

  // Edit field modal methods
  openEditFieldModal(field: any): void {
    this.selectedField = field;
    this.editFieldValue = field.value || '';
    this.editReason = '';
    this.isEditFieldModalOpen = true;
  }

  closeEditFieldModal(): void {
    this.isEditFieldModalOpen = false;
    this.selectedField = null;
    this.editFieldValue = '';
    this.editReason = '';
  }

  confirmEditField(): void {
    if (this.editReason.trim()) {
      // Here you would typically save the field edit to your backend
      console.log('Field edit confirmed:', {
        field: this.selectedField,
        newValue: this.editFieldValue,
        reason: this.editReason
      });
      
      // Update the field value locally
      if (this.selectedField) {
        this.selectedField.value = this.editFieldValue;
      }
      
      // Close the modal
      this.closeEditFieldModal();
      
      // You could also trigger a form update or API call here
    } else {
      alert('Please provide a reason for editing this field.');
    }
  }

  cancelEditField(): void {
    this.closeEditFieldModal();
  }
}